import { Grid, Typography } from '@mui/material'
import PrescriptionSectionCard from './PrescriptionSectionCard'
import TemplateDoctorInfo from '../TemplateDoctorInfo'
import { hasTwoDoctorHeader } from '../utils/prescriptionLayoutConfig'
import PictureUploadComponent from 'src/consumer/components/Helpers/PictureUploadComponent/PictureUploadComponent'

/**
 * Section for doctor details in prescription template
 * Handles primary doctor info, second doctor (if applicable), signature, and logo
 */
export default function DoctorDetailsSection({
  prescriptionTemplate,
  handleChange,
  handleChangeSecondDoctor,
  disabled,
}) {
  const showSecondDoctor = hasTwoDoctorHeader(prescriptionTemplate?.layout)

  return (
    <PrescriptionSectionCard heading="Doctor Details">
      <TemplateDoctorInfo
        disabled={disabled}
        doctorInfo={prescriptionTemplate}
        handleChangeObject={handleChange}
      />

      {showSecondDoctor && (
        <>
          <Grid item xs={12}>
            <Typography variant="subtitle2" fontWeight={600} color="text.secondary" sx={{ mt: 1 }}>
              Second Doctor Info
            </Typography>
          </Grid>
          <TemplateDoctorInfo
            disabled={disabled}
            doctorInfo={prescriptionTemplate?.otherDoctorInfos?.[0]}
            handleChangeObject={handleChangeSecondDoctor}
          />
        </>
      )}

      {/* Signature image and details are in SignatureDetailsSection (signatureDetails payload) */}

      <Grid item xs={12}>
        <PictureUploadComponent
          aspectHeight={50}
          aspectWidth={50}
          showRemoveButton
          id="clinicBrandLogo"
          value={prescriptionTemplate?.clinicBrandLogo}
          title="Clinic Brand Logo"
          onChange={handleChange}
        />
      </Grid>
    </PrescriptionSectionCard>
  )
}
